import React from 'react';
import { DataGrid, GridColumns } from '@material-ui/data-grid';
import { ContainerTable, ButtonRow } from './styles';
import { GoPencil } from 'react-icons/go';
import { FaTrash } from 'react-icons/fa';
import { useModulo } from '../../hooks/useModulo';
import { deleteItens } from '~/utils/masterDetail';
import { subModuloProps } from '../../types';
import { toast } from 'react-toastify';

export const CustomTable: React.FC = () => {
  const {
    rows,
    loadingTable,
    handleOpenModal,
    setIsEditing,
    masterDetail,
    setMasterDetail,
    formModal: { setValue, reset },
    setRows,
  } = useModulo();
  const columns: GridColumns = [
    {
      field: 'num_ordem_menu',
      headerName: 'Ordem',
      headerAlign: 'left',
      sortable: false,
      align: 'center',
      disableColumnMenu: true,
    },
    {
      field: 'des_modulo_secao',
      headerName: 'Descrição',
      headerAlign: 'left',
      sortable: false,
      align: 'left',
      disableColumnMenu: true,
      flex: 1,
    },
    {
      field: 'qtd_telas',
      headerName: 'Qtd. Telas',
      headerAlign: 'left',
      sortable: false,
      align: 'center',
      disableColumnMenu: true,
      width: 200,
    },
    {
      field: '',
      headerName: 'Ações',
      headerAlign: 'center',
      sortable: false,
      align: 'center',
      disableColumnMenu: true,
      width: 150,
      headerClassName: 'hideRightSeparator',
      renderCell: (params: { row: any }) => {
        const { row } = params;
        return (
          <>
            <ButtonRow
              title="Editar"
              type="button"
              onClick={() => {
                setValue('des_modulo_secao', row.des_modulo_secao);
                setIsEditing(row);
                handleOpenModal(true);
              }}
              disabled={false}
              isBlocked={false}
            >
              <GoPencil size={20} style={{ color: '#72ab90' }} />
            </ButtonRow>
            <ButtonRow
              title="Remover"
              type="button"
              onClick={() => onRemoveTable(row)}
              disabled={false}
              isBlocked={false}
            >
              <FaTrash size={20} style={{ color: '#e63c3c' }} />
            </ButtonRow>
          </>
        );
      },
    },
  ];

  const onRemoveTable = async (row: subModuloProps) => {
    if (row.qtd_telas > 0) {
      return toast.warn(
        'Não é possível remover um Submódulo que possui telas vinculadas',
      );
    }
    const rowsUpdate: any = deleteItens(
      'subModulos',
      row.uuid,
      masterDetail,
      setMasterDetail,
    );
    setTimeout(() => {
      setRows(rowsUpdate);
      reset();
    }, 50);
  };

  return (
    <ContainerTable>
      <DataGrid
        style={{ minHeight: '380px' }}
        className="table mt-2"
        pageSize={5}
        rows={rows}
        columns={columns}
        loading={loadingTable}
        sortModel={[{ field: 'num_ordem_menu', sort: 'asc' }]}
        getRowId={(row) => row.uuid}
        disableColumnFilter
        disableColumnSelector
        disableColumnMenu
        disableSelectionOnClick
        localeText={{
          noRowsLabel: 'Nenhum registro encontrado....',
          columnMenuLabel: 'Menu',
          columnMenuFilter: 'Filtrar',
          columnMenuHideColumn: 'Esconder',
          columnMenuUnsort: 'Não ordenar',
          columnMenuSortAsc: 'Ordernar ASC',
          columnMenuSortDesc: 'Ordernar DESC',
          columnMenuShowColumns: 'Mostrar columnas',
        }}
      />
    </ContainerTable>
  );
};
